import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
// import FilterItem from "../FilterItem";
import Switcher from "../../../UI/Switcher/Switcher";

export default function DeluxeBoolean(props) {
  const {
    checked,
    value = true,
    onChange,
    onLabelOverride,
    offLabelOverride,
  } = props;
  const firstTimeRef = useRef(true);

  const handleValueChange = () => {
    onChange({ checked: true, value: +!value });
  };

  useEffect(() => {
    if (firstTimeRef.current) {
      const filter = checked
        ? { checked: false }
        : { checked: true, value: +value };

      onChange(filter);
      firstTimeRef.current = false;
    }
  }, [checked, onChange, value]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div style={{ position: "relative", top: 4, marginRight: -16 }}>
        <Switcher
          cy="boolean-filter-toggle"
          leftLabel={
            value
              ? `${onLabelOverride || "Value: Yes"}`
              : `${offLabelOverride || "Value: No"}`
          }
          checked={value}
          handleSwitchChange={handleValueChange}
          inContent={false}
        />
      </div>
    </div>
  );
}

DeluxeBoolean.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
};
